/**
 * Gets the appropriate question text based on the user's language
 * Supports language variants (e.g., 'es-ES', 'fr-FR')
 * Falls back to English if the requested language is not available
 *
 * @param question The question data object containing multilingual text
 * @param userLanguage The user's language code (e.g., 'en', 'es', 'fr', 'es-ES')
 * @returns The localized question text
 */
export default function getLocalizedQuestionText(question, userLanguage = 'en') {
    if (!question || !question.data) {
        return '';
    }
    const { data } = question;
    // Handle language variants (e.g., 'es-ES' should use 'es' content)
    const baseLanguage = userLanguage.split('-')[0].toLowerCase();
    // Check for specific language variants first
    if (baseLanguage === 'es' && data.esQuestionText) {
        return data.esQuestionText;
    }
    if (baseLanguage === 'fr' && data.frQuestionText) {
        return data.frQuestionText;
    }
    // Default to English
    // Ensure questionText is a string, not an object
    const { questionText } = data;
    if (typeof questionText === 'string') {
        return questionText;
    }
    // If questionText is an object or other non-string type, return empty string
    return '';
}
